/**
 * BeButton의 샘플용 화면
 */

const BUTTON_TYPES = ['is-primary', 'is-info', 'is-success', 'is-warning', 'is-danger'] // 버튼의 타입 배열
const BUTTON_AUTHORITIES = ['R', 'C', 'U', 'D', 'S'] // 버튼 권한 배열

export default {
  computed: {
    /**
     * 버튼의 현재 타입을 구한다.
     * @returns {string} 버튼의 Toogle된 타입
     */
    currentButtonType () {
      return BUTTON_TYPES[this.indexButtonType]
    },
    /**
     * 버튼의 현재 권한을 구한다.
     * @returns {string} 버튼의 Toogle된 권한
     */
    currentButtonAuthority () {
      return BUTTON_AUTHORITIES[this.indexButtonAuthority]
    }
  }, // end computed
  methods: {
    /**
     * 일반 버튼 클릭 이벤트 처리
     */
    onClickButton () {
      this.$buefy.toast.open({
        message: '버튼이 클릭되었습니다.',
        type: 'is-info',
        queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
      })
    },
    /**
     * 타입 가변 테스트 버튼 클릭 이벤트 처리
     */
    onClickToggleButtonType () {
      this.toggleButtonType()
    },

    /**
     * 권한 가변 테스트 버튼 클릭 이벤트 처리
     */
    onClickToggleButtonAuthority () {
      this.toggleButtonAuthority()
    },
    /**
     * 버튼 타입 Toggle을 위해 index를 1 증가 시킨다.
     */
    toggleButtonType () {
      this.indexButtonType = (this.indexButtonType + 1) % BUTTON_TYPES.length
    },
    /**
     * 버튼 권한 Toggle을 위해 index를 1 증가 시킨다.
     */
    toggleButtonAuthority () {
      this.indexButtonAuthority = (this.indexButtonAuthority + 1) % BUTTON_AUTHORITIES.length
    }
  }, // end methods
  data () {
    return {
      indexButtonType: 0, // 버튼 타입 Index(토글용)
      indexButtonAuthority: 0 // 버튼 권한 Index(토글용)
    }
  }
}
